import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Footer con i link a Privacy Policy, Cookie Policy e Termini e Condizioni,
 * usato sia nelle pagine autenticate sia in quelle pubbliche.
 *
 * `variant`:
 *  - "muted"  → testo tenue, per l'uso in fondo all'app loggata;
 *  - "public" → leggermente più marcato, per le pagine pubbliche su sfondo chiaro.
 */
const LegalFooter: React.FC<{ variant?: 'muted' | 'public'; className?: string }> = ({
    variant = 'muted',
    className = '',
}) => {
    const year = new Date().getFullYear();
    const linkCls =
        variant === 'public'
            ? 'text-slate-500 hover:text-rose-600 underline-offset-2 hover:underline'
            : 'text-slate-400 hover:text-slate-600 underline-offset-2 hover:underline';

    return (
        <footer
            className={`w-full py-4 px-4 text-[12px] text-slate-400 ${className}`}
        >
            <div className="max-w-3xl mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center">
                <Link to="/privacy-policy" className={linkCls}>Privacy Policy</Link>
                <span className="text-slate-300">·</span>
                <Link to="/cookie-policy" className={linkCls}>Cookie Policy</Link>
                <span className="text-slate-300">·</span>
                <Link to="/termini-condizioni" className={linkCls}>Termini e Condizioni</Link>
                <span className="text-slate-300 hidden sm:inline">·</span>
                <span className="w-full sm:w-auto text-slate-400">© {year} Ultra Detective</span>
            </div>
        </footer>
    );
};

export default LegalFooter;
